if (!customElements.get('mikan-category-launcher')) {
    customElements.define('mikan-category-launcher', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.header = this.closest('header-component');
        this.navigation = this.previousElementSibling;
        this.button = this.querySelector('.mikan-category-launcher__button');
        this.dialog = this.querySelector('dialog');
        this.placeholder = this.querySelector('[data-category-placeholder]');
        this.content = this.querySelector('.mikan-category-sheet__content');
        if (!this.header || !this.navigation?.matches('.mikan-mobile-filters')) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = window.matchMedia('(max-width: 989px)');
        document.body.append(this.button);
        this.lastScrollY = window.scrollY;
        this.scrollingDown = false;
        this.update = () => {
          if (!this.mobile.matches && this.dialog.open) this.dialog.close();
          this.button.hidden = !this.mobile.matches || this.header.getBoundingClientRect().bottom > 0 || this.scrollingDown;
        };
        this.button.addEventListener('click', () => {
          if (this.dialog.open || !this.mobile.matches) return;
          this.placeholder.style.height = `${this.navigation.getBoundingClientRect().height}px`;
          this.placeholder.hidden = false;
          this.navigation.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
          this.content.append(this.navigation);
          this.dialog.showModal();
          this.button.setAttribute('aria-expanded', 'true');
          this.querySelector('.mikan-category-sheet__close').focus({ preventScroll: true });
        }, options);
        this.querySelector('.mikan-category-sheet__close').addEventListener('click', () => this.dialog.close(), options);
        this.content.addEventListener('click', event => {
          if (event.target.closest('a[href]')) this.dialog.close();
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientY < rect.top || event.clientY > rect.bottom || event.clientX < rect.left || event.clientX > rect.right) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.before(this.navigation);
          this.placeholder.hidden = true;
          this.button.setAttribute('aria-expanded', 'false');
          this.update();
        }, options);
        this.observer = new IntersectionObserver(this.update, { threshold: 0 });
        this.observer.observe(this.header);
        this.mobile.addEventListener('change', this.update, options);
        window.addEventListener('pageshow', this.update, options);
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const next = window.scrollY;
            if (Math.abs(next - this.lastScrollY) > 6) {
              this.scrollingDown = next > this.lastScrollY;
              this.lastScrollY = next;
              if (document.activeElement !== this.button) this.update();
            }
          });
        };
        window.addEventListener('scroll', this.onScroll, { ...options, passive: true });
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.controller?.abort();
        this.controller = null;
        if (this.dialog?.open) this.dialog.close();
        if (this.button) this.append(this.button);
        if (this.navigation && this.content?.contains(this.navigation) && this.parentNode) this.before(this.navigation);
      }
    });
  }

